import script from "./EventsMap.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsMap.vue?vue&type=script&setup=true&lang=js"

import "./EventsMap.vue?vue&type=style&index=0&id=1907aa9d&lang=css"

const __exports__ = script;

export default __exports__